import { useAuth0 } from '@auth0/auth0-react';
import { useRouter } from '@tanstack/react-router';
import { ReactNode, useEffect } from 'react';

export default function Redirect({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth0();
  const router = useRouter();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      router.history.push('/plugins/outlook/taskpane');
    }
  }, [isAuthenticated, isLoading, router]);

  return children;
}
